export const CoreIcon = ({ id }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42" fill="none">
    <path
      d="M25.648 5.7101C25.648 3.12517 23.5536 1.02966 20.97 1.02966C18.3864 1.02966 16.292 3.12517 16.292 5.7101V10.8542C16.292 13.4392 18.3864 15.5347 20.97 15.5347C23.5536 15.5347 25.648 13.4392 25.648 10.8542V5.7101Z"
      fill="url(#paint0_linear_1894_128244)"
    />
    <path
      d="M7.34254 12.2735C4.88412 11.4748 2.24397 12.8191 1.44559 15.2763C0.647212 17.7334 1.99294 20.3729 4.45136 21.1717L9.34372 22.7613C11.8021 23.5601 14.4423 22.2157 15.2407 19.7586C16.0391 17.3014 14.6933 14.662 12.2349 13.8632L7.34254 12.2735Z"
      fill="url(#paint1_linear_1894_128244)"
    />
    <path
      d="M7.9192 31.7187C6.39981 33.81 6.86253 36.7364 8.9527 38.255C11.0429 39.7736 13.969 39.3093 15.4884 37.2181L18.512 33.0564C20.0314 30.9651 19.5687 28.0388 17.4785 26.5202C15.3884 25.0016 12.4622 25.4658 10.9428 27.557L7.9192 31.7187Z"
      fill="url(#paint2_linear_1894_128244)"
    />
    <path
      d="M26.5967 37.1648C28.1161 39.2561 31.0422 39.7203 33.1324 38.2017C35.2226 36.6831 35.6853 33.7567 34.1659 31.6655L31.1423 27.5038C29.6229 25.4125 26.6967 24.9483 24.6066 26.4669C22.5164 27.9855 22.0537 30.9119 23.5731 33.0031L26.5967 37.1648Z"
      fill="url(#paint3_linear_1894_128244)"
    />
    <path
      d="M21.0168 26.2007C23.5804 26.2007 25.6586 24.1225 25.6586 21.5589C25.6586 18.9953 23.5804 16.9171 21.0168 16.9171C18.4532 16.9171 16.375 18.9953 16.375 21.5589C16.375 24.1225 18.4532 26.2007 21.0168 26.2007Z"
      fill="#6161FF"
    />
    <path
      d="M5.87306 21.3748C8.45058 21.3748 10.5401 19.2853 10.5401 16.7078C10.5401 14.1303 8.45058 12.0408 5.87306 12.0408C3.29555 12.0408 1.20605 14.1303 1.20605 16.7078C1.20605 19.2853 3.29555 21.3748 5.87306 21.3748Z"
      fill="#6161FF"
    />
    <path
      d="M20.9712 10.3467C23.5533 10.3467 25.6466 8.25353 25.6466 5.67142C25.6466 3.08931 23.5533 0.996094 20.9712 0.996094C18.3891 0.996094 16.2959 3.08931 16.2959 5.67142C16.2959 8.25353 18.3891 10.3467 20.9712 10.3467Z"
      fill="#6161FF"
    />
    <path
      d="M11.7039 39.1605C14.2905 39.1605 16.3873 37.0637 16.3873 34.4771C16.3873 31.8905 14.2905 29.7937 11.7039 29.7937C9.11733 29.7937 7.02051 31.8905 7.02051 34.4771C7.02051 37.0637 9.11733 39.1605 11.7039 39.1605Z"
      fill="#6161FF"
    />
    <path
      d="M30.3911 39.1112C32.9721 39.1112 35.0644 37.0189 35.0644 34.4379C35.0644 31.8568 32.9721 29.7645 30.3911 29.7645C27.8101 29.7645 25.7178 31.8568 25.7178 34.4379C25.7178 37.0189 27.8101 39.1112 30.3911 39.1112Z"
      fill="#6161FF"
    />
    <path
      d="M34.6575 12.2735C37.1159 11.4748 39.756 12.8191 40.5544 15.2763C41.3528 17.7334 40.0071 20.3729 37.5486 21.1717L32.6563 22.7613C30.1979 23.5601 27.5577 22.2157 26.7593 19.7586C25.9609 17.3014 27.3067 14.662 29.7651 13.8632L34.6575 12.2735Z"
      fill="url(#paint4_linear_1894_128244)"
    />
    <path
      d="M36.1269 21.3749C33.5494 21.3749 31.4599 19.2854 31.4599 16.7079C31.4599 14.1304 33.5494 12.0409 36.1269 12.0409C38.7045 12.0409 40.7939 14.1304 40.7939 16.7079C40.7939 19.2854 38.7045 21.3749 36.1269 21.3749Z"
      fill="#6161FF"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1894_128244"
        x1="20.9394"
        y1="-7.95948"
        x2="21.0423"
        y2="16.4694"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.411458" stop-color="#6C6CFF" stop-opacity="0.9" />
        <stop offset="1" stop-color="#6C6CFF" stop-opacity="0.1" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1894_128244"
        x1="-7.11305"
        y1="12.5276"
        x2="16.152"
        y2="19.9787"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.411458" stop-color="#6C6CFF" stop-opacity="0.9" />
        <stop offset="1" stop-color="#6C6CFF" stop-opacity="0.1" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1894_128244"
        x1="3.69378"
        y1="45.5453"
        x2="17.9695"
        y2="25.7215"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.411458" stop-color="#6C6CFF" stop-opacity="0.9" />
        <stop offset="1" stop-color="#6C6CFF" stop-opacity="0.1" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_1894_128244"
        x1="38.4408"
        y1="45.4561"
        x2="23.9987"
        y2="25.7532"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.411458" stop-color="#6C6CFF" stop-opacity="0.9" />
        <stop offset="1" stop-color="#6C6CFF" stop-opacity="0.1" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_1894_128244"
        x1="49.1131"
        y1="12.5276"
        x2="25.848"
        y2="19.9787"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.411458" stop-color="#6C6CFF" stop-opacity="0.9" />
        <stop offset="1" stop-color="#6C6CFF" stop-opacity="0.1" />
      </linearGradient>
    </defs>
  </svg>
);
